export enum DrawerRoutes {
  VIEWER = "Мій Розклад",
  REGLAMENT = "Регламент",
  TEACHERS = "Викладачі",
  CONTACTS = "Контакти",
  NEWS = "Новини",

  TESTS = "Тести",
  QnA = "Q&A",
  EDITOR = "Редактор",
  SETTINGS = "Налаштування",
  ABOUT = "Про Застосунок",
}
